export default __webpack_public_path__ + "static/media/d_proposal.47421b06.webp";